module.exports = __webpack_public_path__ + "img/black-week-4-estrelas.91f181b1.webp";